import * as React from "react";
import {
  Show,
  TextField,
  ShowProps,
  useRecordContext,
  DateField,
  ArrayField,
  TabbedShowLayout,
  Datagrid,
  ShowButton,
} from "react-admin";
import { Card, CardActions, Divider } from "@mui/material";
import { CreateInterviewModal } from "../Interviews";

const JobApplicationTitle = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <>{`${record?.applicant?.user?.fullName} - ${record?.offer?.title}`}</>;
};

export const ViewJobApplication: React.FC<ShowProps> = (props) => {
  return (
    <Show {...props} title={<JobApplicationTitle />}>
      <TabbedShowLayout spacing={2} divider={<Divider flexItem />}>
        <TabbedShowLayout.Tab label="Oferta" spacing={100}>
          <DateField source="createdAt" label="Fecha de postulación" />
          <TextField source="offer.title" label="Título" />
          <TextField source="offer.reference" label="Referencia" />

          <TextField
            source="applicant.user.fullName"
            label="Nombre del postulante"
          />
          <TextField
            source="applicant.user.email"
            label="Email del postulante"
          />
          <TextField
            source="applicant.user.phone"
            label="Teléfono"
            emptyText="No especificado"
          />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Entrevistas" path="interviews">
          <>
            <Card>
              <CardActions
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <CreateInterviewModal {...props} />
              </CardActions>
              <ArrayField source="interviews">
                <Datagrid>
                  <TextField
                    source="interviewer.fullName"
                    label="Entrevistador"
                  />
                  <DateField
                    source="interviewDate"
                    label="Fecha de entrevista"
                  />
                  <ShowButton label="Ver" resource="interviews" />
                </Datagrid>
              </ArrayField>
            </Card>
          </>
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  );
};
